var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('assigned-vessel-list',{attrs:{"vessels":_vm.getManningVessels,"onboarding-crews":_vm.getOnboardingCrews,"ashore-crews":_vm.getAshoreCrews,"crews-roles":_vm.getCrewsRoles,"vessel-alerts":_vm.getManningVesselsAlerts,"crew-alerts":_vm.getCrewAlerts,"crew-alert-settings":_vm.getCrewAlertSettings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }